import { Col, Row } from 'react-bootstrap';
// import EcomTopRegionsMap from 'components/leaflet-maps/EcomTopRegionsMap';
import RouteDeadLinersCard from './charts/RouteDeadlinesCard';
import ThermalAnomaliesCard from './charts/ThermalAnomaliesCard';
import MonitoringDeadlinesCard from './charts/MonitoringDeadlinesCard';
import ExecutionAnomaliesDealinesCard from './charts/ExecutionAnomaliesDealinesCard';
// import AnomalyRecordList from './AnomalyRecordList';
import { useEffect, useState } from 'react';
import TabListContainer from './TabListContainer';
import { DatabaseService } from './stores/DatabaseService';
import { usePowerStationFilterStore } from './stores/PowerStationFilterStore';
import PowerStationMap from './leaflet-maps/PowerStationMap';

const PowerStations = () => {
    // const dbService = DatabaseService.getInstance();
    // const refreshData = usePowerStationFilterStore((state) => state.refreshData);

    // useEffect(() => {
    //     if (dbService.isInitialized) {
    //         requestIdleCallback(() => {
    //             console.log('Power Stations: Refresh Data');
    //             refreshData();
    //         });
    //     }
    // }, [dbService.isInitialized, refreshData]);


    return (
        <>
            <div className="pb-3">
                <Row className="g-3">
                    <Col xs={12} xxl={4}>
                        <PowerStationMap />
                    </Col>
                    <Col xs={12} xxl={8}>
                        <Row className="g-3">
                            <Col xs={12} md={3}>
                                <RouteDeadLinersCard />
                            </Col>
                            <Col xs={12} md={3}>
                                <ThermalAnomaliesCard />
                            </Col>
                            <Col xs={12} md={3}>
                                <MonitoringDeadlinesCard />
                            </Col>
                            <Col xs={12} md={3}>
                                <ExecutionAnomaliesDealinesCard />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
            <Row className="g-4">
                <TabListContainer />
            </Row>
        </>
    );
};

export default PowerStations;
